export enum TelemetryOPEEnum {
  GetTimeChartMetrics = 'getTimeChartMetrics',
  DownloadTimeChartMetrics = 'downloadTimeChartMetrics',
}
